import React, { PropTypes } from 'react';
import Photo from './photo';
import Lightbox from 'react-image-lightbox';

class PhotoList extends React.Component {

    constructor(props) {
        super(props);

        var self = this;
        
        self.state = {
            isPreviewOpen: false,
            previewPhotoIndex: null
        };
    }

    onCloseRequest = () => {
        var self = this;

        self.setState({
            isPreviewOpen: false
        });
    }

    onMoveNextRequest = () => {
        var self = this,
            photos = self.props.place.photos;

        self.setState({
            previewPhotoIndex: (self.state.previewPhotoIndex + 1) % photos.length
        });
    }

    onMovePrevRequest = () => {
        var self = this,
            photos = self.props.place.photos,
            photosCount = photos.length;

        self.setState({
            previewPhotoIndex: (self.state.previewPhotoIndex + photosCount - 1) % photosCount
        });
    }

    render () {
        var self = this,
            place = self.props.place,
            photos = self.props.place != null ? self.props.place.photos : null,
            selectedPhotoIndex = self.props.selectedPhotoIndex,
            previewPhotoIndex = self.state.previewPhotoIndex;

        if (place == null) {
            return null;
        }

        if (photos == null || !photos.length) {
            return self.props.children;
        }

        return (
            <div className="photo-list-container fade-in">
                {
                    photos.map((url, i) => {
                        return <Photo key={ i }
                                      url={ url }
                                      isSelected={ self.props.selectedPhotoIndex != null ? self.props.selectedPhotoIndex === i : i === 0 }
                                      onSelectionRequested={ () => self.props.onPhotoSelected(i) }
                                      onPreviewRequested={ () => self.setState({ isPreviewOpen: true, previewPhotoIndex: i }) } />
                    })
                }
                {
                    self.state.isPreviewOpen &&
                        <Lightbox mainSrc={ photos[previewPhotoIndex] }
                                  nextSrc={ photos[(previewPhotoIndex + 1) % photos.length] }
                                  prevSrc={ photos[(previewPhotoIndex + photos.length - 1) % photos.length] }
                                  onCloseRequest={ self.onCloseRequest }
                                  onMoveNextRequest={ self.onMoveNextRequest }
                                  onMovePrevRequest={ self.onMovePrevRequest }
                                  enableZoom={ false }
                                  reactModalStyle={ { overlay: { zIndex: 1050 } } } />
                }
            </div>
        );
    }
};

export default PhotoList;


// WEBPACK FOOTER //
// ./src/app/components/checkin/photoList.jsx